export default "__VITE_ASSET__BvB0Xr7d__"